/**
 * Yandex Metrika.
 *
 * Загружает счётчик 93216180 один раз.
 * На localhost не запускается — чтобы не засорять статистику с разработки.
 * Если нужно тестировать на dev — закомментируй guard ниже.
 */
export function initMetrika() {
  // ─── Не трекаем локально ─────────────────────────
  const host = window.location.hostname;
  if (host === "localhost" || host === "127.0.0.1" || host.startsWith("192.168.")) {
    return;
  }

  // ─── Оригинальный сниппет Метрики ────────────────
  (function (m, e, t, r, i, k, a) {
    m[i] = m[i] || function () { (m[i].a = m[i].a || []).push(arguments); };
    m[i].l = 1 * new Date();
    for (let j = 0; j < document.scripts.length; j++) {
      if (document.scripts[j].src === r) return;
    }
    k = e.createElement(t);
    a = e.getElementsByTagName(t)[0];
    k.async = 1;
    k.src = r;
    a.parentNode.insertBefore(k, a);
  })(
    window,
    document,
    "script",
    "https://mc.yandex.ru/metrika/tag.js",
    "ym"
  );

  // ─── Инициализация счётчика ──────────────────────
  window.ym(93216180, "init", {
    webvisor: true,
    clickmap: true,
    accurateTrackBounce: true,
    trackLinks: true,
  });
}
